import http from "@/http-common";

const BASE = "statistics/employee-attendance";

class EmployeeAttendanceStatisticsService {
  getSummary() {
    return http.get(`${BASE}/summary`);
  }

  getTrend() {
    return http.get(`${BASE}/trend`);
  }

  getKpi(employeeId, startDate, endDate) {
    return http.get(`${BASE}/kpi`, {
      params: { employeeId, startDate, endDate }
    });
  }
}

export default new EmployeeAttendanceStatisticsService();
